import { useSyncExternalStore } from "react";

// The toggle only surfaces a generic snackbar when the cloud rejects a recovery source change.
// The debug drawer needs the actual response, so the last failure is kept here, outside any one
// component, and read back with useSyncExternalStore.
export type RecoverySourceUpdateError = {
  at: string;
  requestedFitnessAppId: number | null;
  status?: number;
  message?: string;
  body?: unknown;
};

let lastError: RecoverySourceUpdateError | undefined;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

// cloud-client-ts rethrows the axios error, so status and body live under `response`.
export const recordRecoverySourceUpdateError = (
  requestedFitnessAppId: number | null,
  error: unknown
) => {
  const axiosLike = error as {
    message?: string;
    response?: { status?: number; data?: unknown };
  } | null;
  lastError = {
    at: new Date().toISOString(),
    requestedFitnessAppId,
    status: axiosLike?.response?.status,
    message: axiosLike?.message,
    body: axiosLike?.response?.data,
  };
  listeners.forEach((listener) => listener());
};

export const clearRecoverySourceUpdateError = () => {
  lastError = undefined;
  listeners.forEach((listener) => listener());
};

export const useLastRecoverySourceUpdateError = () =>
  useSyncExternalStore(
    subscribe,
    () => lastError,
    () => lastError
  );
